import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App/App';
import registerServiceWorker from './registerServiceWorker';
import AppStore, { AppSaga, sagaMiddleware } from './store';
import * as queryString from 'query-string';

sagaMiddleware.run(AppSaga(queryString.parse(window.location.search)));
ReactDOM.render(<App store={AppStore}/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js